import { Component, output, ViewChild } from '@angular/core';
import { RecaptchaComponent } from 'ng-recaptcha';
import { environment } from '@environments/environment';

@Component({
  standalone: false,
  selector: 'ingsv-adm-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss']
})
export class CaptchaComponent {
  readonly resolved = output<any>();
  @ViewChild(RecaptchaComponent, { static: false }) recaptcha: RecaptchaComponent;

  env = environment;

  captchaResolved(event: string): void {
    this.resolved.emit(event);
  }

  reset(): void {
    if (this.recaptcha) {
      this.recaptcha.reset();
    }
  }
}
